export default "__VITE_ASSET__7abb5a6e__"